import React, { Component } from 'react';
import logo from "../images/KaryaTalents_logo.png";
import lamp from "../images/pid_lamp.svg"
import pid_4 from "../images/pid_4.svg"
import pid_1 from "../images/pid_1.svg"
import { getQuestPID_StandAlone, submitPID_StandAlone} from "../_actions/quest";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandMoreIcon from '../images/top_acc.svg';
import Loading from "../components/Loading";
import ReactPixel from 'react-facebook-pixel';
import { LazyLoadImage } from 'react-lazy-load-image-component';


class componentName extends Component {
    constructor() {
        super();
        this.state = {
          id_quest: 1,
          list_quest:[],
          page:1,
          length:0,
          complete:"",
          next : true,
          back:false,
          data_post:{
              user_id:"",
              answer:[],
        },
        data:[],
        dataAnswer:[],
        dataSubmit:{
            user_id:"121",
            answer:[]
        }
          
        }
    }

    componentDidMount() {
        this.props.getQuestPID_StandAlone();
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.track(window.location.pathname);
        window.scrollTo(0, 0)
      }
      
      componentDidUpdate(prevProps, prevState, snapshot){
          if (prevState.page > this.state.page ){
            if (parseInt(this.state.complete.substr(1)*4) <= this.state.list_quest.length && this.state.list_quest.length !== 0 ){
                this.setState({next:true})
                console.log("cek prevstate dulu")
            }else{
                this.setState({next:false})
                // console.log("cek prevstate dulu")
            }
              
          }
      }

    next_quest=()=>{
        let n
        if (this.state.page <= 15){
            n = this.state.page + 1
        }else{
            n= this.state.page + 0
            this.submit()
        }

        this.setState({
            id_quest: this.state.id_quest+4,
            page: n,
            next: false,
            length: this.state.length + 4})
        
    }
    save_quest=(e)=>{
        this.setState({list_quest:e})
    }
    submit =()=>{
        const arr = this.state.data_post.answer
        const result = {
            userId: sessionStorage.getItem("id-std"),
            answers: [{ "_id": "preamble", "value": "seen" }]
        }
        arr.map(x => {
        let tempObj = {_id: '', value: ["", "", "", ""]}
        let find = result.answers.find(function(post, index) {
            /* eslint eqeqeq: 0 */
            if(post._id == x._id)
            return true;
        });
        if(!find) {
            tempObj._id = x._id
            tempObj.value[x.value_id - 1] = x.value
            result.answers.push(tempObj)
        } else {
            find.value[x.value_id - 1] = x.value
        }
    })
    result.answers.map(x => {
        x.value = JSON.stringify(x.value)
    })
    console.log(result,"ini result")
    this.props.submit1(result);
    // window.location.href="/Personality-Profiler-Stand-Alone"

    }


    handleChange = (title,value,_id) => (e) => {

        let dataRadio = { title, value };
        // var jwt = require("jsonwebtoken");
        // var token1 = sessionStorage.getItem("token");
        // var decode1 = jwt.decode(token1);
        // var user_id = decode1["user_id"];
        var user_id = sessionStorage.getItem("id-std");
        const { todosPerPage, selectedValue, currentPage } = this.state;
        const select = this.state.list_quest.findIndex((selectedValue) => selectedValue.title === title);
        const selectedProfile = this.state.list_quest[select] ? this.state.list_quest[select].title : ""
        const selected = this.state.list_quest[select] ? this.state.list_quest[select].value : ""
        const filter = this.state.list_quest.findIndex((selectedValue) => selectedValue.value === value)
        const filter2 = this.state.list_quest.findIndex((selectedValue) => selectedValue.title === title && selectedValue._id === _id)
        const filter3 = this.state.list_quest.findIndex((selectedValue) => selectedValue._id === _id && selectedValue.value === value)
        const selectedValue2 = this.state.list_quest[filter] ? this.state.list_quest[filter].value : ""
        let indexClick = this.state.list_quest.findIndex((x, index) => x.title === title && x.value === value && x._id == _id)

        if ( indexClick == -1 && filter3 === -1 && filter2 === -1) {
            let testing = { title, value, _id }
            this.state.data.push({value})

            this.state.dataAnswer.push({_id : _id, value_id : value, value : title})
            this.setState({data_post:{answer:this.state.dataAnswer,user_id: user_id }})

            let temp = []
            temp.push(testing)
            this.state.list_quest.push({ title, value, _id })
            this.setState({ list_quest: this.state.list_quest})
            this.setState({ complete: _id})
            if (parseInt(this.state.complete.substr(1)*4) === this.state.list_quest.length ){
                this.setState({next:true})
            }
        } else if(indexClick != -1){
          this.state.list_quest[filter2] = { title, value, _id}
            this.state.list_quest.splice(indexClick, 1)
            this.setState({ list_quest: this.state.list_quest})
            // this.setState({ length: this.state.length - 1})
        }
      }
      backPage=()=>{
        this.setState({page:this.state.page-1, next: true,
             length: this.state.length - 4,
             id_quest: this.state.id_quest-4,
             back: true})
      }

      backToHomepage=()=>{
        window.location.href="/"
    }


    render() {
        const {data_QSA, isLoading, error} = this.props.dataQuest1;
        let n_val
        data_QSA.data != undefined && data_QSA.data.length > 0 ?
        data_QSA.data.map((item,i)=>{
            if (i==0){
                n_val = item
            }
        }):console.log("error aa");
    
        const nil = n_val !==undefined? n_val.questions.length - 1:console.log("error");
        // const nil= 1
        if (isLoading) {
        return (
            <React.Fragment>
            <Loading />
            </React.Fragment>
        );
        }


        const n = this.state.id_quest
        let btn_Next 
        let btn_Prev 
        // if (parseInt(this.state.complete.substr(1)*4) === this.state.list_quest.length && this.state.list_quest.length !== 0 && ((this.state.page *4)== this.state.list_quest.length) ){
        if ( this.state.list_quest.length !== 0 && ((this.state.page *4)== this.state.list_quest.length) ){
            btn_Next=   <button onClick={this.next_quest} style={{backgroundColor:"#3B6C98", borderColor:"#3B6C98", padding:"0px"}}>
                            <p>Next</p>
                        </button>
        }else if (this.state.back == true && (Math.floor(this.state.list_quest.length/4) >= this.state.page)){
            btn_Next=   <button onClick={this.next_quest} style={{backgroundColor:"#3B6C98", borderColor:"#3B6C98", padding:"0px"}}>
                            <p>Next</p>
                        </button>
        }else{
            btn_Next=   <button style={{padding:"0px"}} >
                            <p>Next</p>
                        </button>
        }
        
        if (this.state.page > 1 ){
            btn_Prev =   <button onClick={this.backPage} style={{backgroundColor:"#FFFFFF", borderColor:"#3B6C98", padding:"0px"}}>
                            <p style={{color:"#3B6C98"}}>Back</p>
                        </button>
        }else{
            btn_Prev =   <p style={{width:"90px"}}> </p>
        }

       
      



        return (
            <div>
                <div className="header_PID width-100">
                <a  onClick={this.backToHomepage} style={{margin:"auto"}}>
                    <LazyLoadImage effect="blur" loading="lazy" alt="" src={logo} />
                    </a>
                </div>
                <div className="box-wrapper personality_getStarted PID_Questions qs_" >
                    <div className="wrapper">
                        <div className="content">
                            <div className="page-container ">
                                <div className="page-container-outer " style={{marginBottom:"50px"}}>
                                    <div className="box_PID">
                                      <div className="flex width-100 columnPID_Mobile columnTablet">

                                        {/* <div className="dekstop"> */}
                                          <div className="width-35 dekstop">
                                              <div className="PID_left">
                                                <div className="progress_profile_PID">
                                                    <h2>Personality Profiler</h2>
                                                    <div className="progressBar_PID">
                                                        <div className="progress-Quest" style={{width:`${(this.state.length / (nil * 4))* 98}%`}}>
                                                            {this.state.length > 0  &&
                                                            <p>{`${Math.ceil((this.state.length / (nil *4))* 100)}%`} </p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-Content flex column">
                                                    <div className="flex_Container">
                                                        <LazyLoadImage effect="blur" loading="lazy" alt="" src={lamp} />
                                                        <p className="title">GUIDE</p>
                                                    </div>
                                                    <div className="width-100" style={{border: "1px solid #F2F2F2", marginBottom:"7px"}} />
                                                    <div className="pid_content_quest">
                                                        <p className="width-100 desc">Order all words on each screen in such a way that all of them describe your personality in the best way</p>
                                                        <div className="rangePID">
                                                            <div className="flex space-between width-80">
                                                                <LazyLoadImage effect="blur" loading="lazy" alt="" src={pid_4} />
                                                                <div className="pid_range_intro"  />
                                                                <LazyLoadImage effect="blur" loading="lazy" alt="" src={pid_1} />
                                                            </div>
                                                        </div>
                                                        <div className="pid_most_least">
                                                            <p>Most Like You</p>
                                                            <p>Least Like You</p>
                                                        </div>
                                                        <p className="width-100 desc" style={{marginBottom:"143px"}}>If you want to remove the marker from the word, click it again and put the word, click it again and put the marker in another line.</p>
                                                    </div>
                                                </div>
                                            </div>
                                          </div>
                                          {/* </div> */}
                                          <div className="mobile">
                                          <div className="width-35">
                                              <div className="PID_left">
                                                <div className="progress_profile_PID">
                                                    <h2>Personality Profiler</h2>
                                                    <div className="progressBar_PID">
                                                        <div className="progress-Quest" style={{width:`${(this.state.length / (nil * 4))* 98}%`}}>
                                                            {this.state.length > 0  &&
                                                            <p>{`${Math.ceil((this.state.length / (nil *4))* 100)}%`} </p>}
                                                        </div>
                                                    </div>
                                                </div>
                                              
                                                <div className="box-Content flex column">
                                                <Accordion>
                                                <AccordionSummary
                                                        expandIcon={<LazyLoadImage effect="blur" loading="lazy" alt="" src={ExpandMoreIcon} />}
                                                        // onClick={this.changeRevert}
                                                        id="panel1a-header"
                                                        >
                                                    <div className="flex_Container">
                                                        <LazyLoadImage effect="blur" loading="lazy" alt="" src={lamp} />
                                                        <p className="title">GUIDE</p>
                                                    </div>
                                                    </AccordionSummary>
                                                    <div className="width-100" style={{border: "1px solid #F2F2F2", marginBottom:"7px"}} />
                                                    <div className="pid_content_quest">
                                                        <p className="width-100 desc">Order all words on each screen in such a way that all of them describe your personality in the best way</p>
                                                        <div className="rangePID">
                                                            <div className="flex space-between width-80">
                                                                <LazyLoadImage effect="blur" loading="lazy" alt="" src={pid_4} />
                                                                <div className="pid_range_intro"  />
                                                                <LazyLoadImage effect="blur" loading="lazy" alt="" src={pid_1} />
                                                            </div>
                                                        </div>
                                                        <div className="pid_most_least">
                                                            <p>Most Like You</p>
                                                            <p>Least Like You</p>
                                                        </div>
                                                        <p className="width-100 desc" style={{marginBottom:"143px"}}>If you want to remove the marker from the word, click it again and put the word, click it again and put the marker in another line.</p>
                                                    </div>
                                                    </Accordion>
                                                </div>
                                               
                                            </div>
                                          </div>
                                          </div>


                                          <div style={{border: "1px solid #F2F2F2", height:"auto"}} />
                                          <div className="width-65">
                                              <div className="box_list_question">
                                                 <div className="width-100 flex space-between desc">
                                                     <p>Most Like You</p>
                                                     <p>Least Like You</p>
                                                 </div>
                                                 <div className="flex width-100 bar_Mobile"  style={{height:"14px", background: "linear-gradient(90deg, #DDB87A 0%, rgba(221, 184, 122, 0) 100%)"}} 
                                                 />
                                                 {n_val!== undefined? 
                                                    n_val.questions.map((item2,i)=>{
                                                        if(i===this.state.page){
                                                        return(
                                                        <div>
                                                        {item2.choices.map((item3,i)=>{
                                                                const select = this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id);
                                                                const selectedProfile = this.state.list_quest[select] ? this.state.list_quest[select].title : ""
                                                                const selected = this.state.list_quest[select] ? this.state.list_quest[select].value : ""
                                                            return(
                                                 <div className="PID_item_question" key={i}>
                                                     <p className="title_quest">{item3.title}</p>
                                                     <p className="body_quest">{item3.subtitle}</p>
                                                     <div className="choice_quest">
                                                     <button onClick={this.handleChange(item3._id,1, item2._id)} style={{
                                                            backgroundColor: this.state.list_quest.findIndex((x, index) => x.title == item3._id && x.value == 1 && x._id == item2._id)!== -1? "#DDB87A":"" 
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title !== item3._id  && selectedValue.value ===1) === -1 &&
                                                            (this.state.list_quest.findIndex((selectedValue) => selectedValue._id == item2._id &&  selectedValue.value === 1) !== -1) ? "":"#FFFFFF"),
                                                            color: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 1)? "white":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 1) === -1)? "":"#BDBDBD"),
                                                            borderColor: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 1)? "#DDB87A":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 1) === -1)? "":"#BDBDBD"),
                                                            }}>
                                                             <p>4</p>
                                                         </button>
                                                         <button onClick={this.handleChange(item3._id,2, item2._id)} style={{
                                                            backgroundColor: this.state.list_quest.findIndex((x, index) => x.title == item3._id && x.value == 2 && x._id == item2._id)!== -1? "#DDB87A":"" 
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title !== item3._id  && selectedValue.value ===2) === -1 &&
                                                            (this.state.list_quest.findIndex((selectedValue) => selectedValue._id == item2._id &&  selectedValue.value === 2) !== -1) ? "":"#FFFFFF"),
                                                            color: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 2)? "white":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 2) === -1)? "":"#BDBDBD"),
                                                            borderColor: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 2)? "#DDB87A":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 2) === -1)? "":"#BDBDBD"),
                                                            }}>
                                                             <p>3</p>
                                                         </button>
                                                         <button  onClick={this.handleChange(item3._id,3, item2._id)} style={{
                                                            backgroundColor: this.state.list_quest.findIndex((x, index) => x.title == item3._id && x.value == 3 && x._id == item2._id)!== -1? "#DDB87A":"" 
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title !== item3._id  && selectedValue.value ===3) === -1 &&
                                                            (this.state.list_quest.findIndex((selectedValue) => selectedValue._id == item2._id &&  selectedValue.value === 3) !== -1) ? "":"#FFFFFF"),
                                                            color: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 3)? "white":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 3) === -1)? "":"#BDBDBD"),
                                                            borderColor: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 3)? "#DDB87A":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 3) === -1)? "":"#BDBDBD"),
                                                            }}>
                                                             <p>2</p>
                                                         </button>
                                                         <button onClick={this.handleChange(item3._id,4, item2._id)} style={{
                                                            backgroundColor: this.state.list_quest.findIndex((x, index) => x.title == item3._id && x.value == 4 && x._id == item2._id)!== -1? "#DDB87A":"" 
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title !== item3._id  && selectedValue.value ===4) === -1 &&
                                                            (this.state.list_quest.findIndex((selectedValue) => selectedValue._id == item2._id &&  selectedValue.value === 4) !== -1) ? "":"#FFFFFF"),
                                                            color: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 4)? "white":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 4) === -1)? "":"#BDBDBD"),
                                                            borderColor: this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id)!== -1 &&
                                                            (selectedProfile === item3._id && selected === 4)? "#DDB87A":""
                                                            || (this.state.list_quest.findIndex((selectedValue) => selectedValue.title === item3._id) === -1   &&
                                                            (this.state.list_quest.findIndex((selectedValue) =>  selectedValue._id == item2._id &&  selectedValue.value === 4) === -1)? "":"#BDBDBD"),
                                                            }}>
                                                             <p>1</p>
                                                         </button>
                                                     </div>
                                                     <div className="flex width-100" style={{border: "1px solid #E0E0E0"}} />
                                                 </div>
                                                  )
                                                })}
                                                </div>
                                           )
                                    } }) : console.log("error")}
                                                 
                                                 <div className="PID_next">
                                                    {btn_Prev}
                                                    <div className="flex">
                                                        <p className="step">{this.state.page} </p>
                                                        <p className="step" style={{color:"#BDBDBD", marginLeft:"5px"}}> / {nil}</p>
                                                    </div>
                                                    {btn_Next}
                                                 </div>

                                              </div>
                                          </div>
                                      </div>
                                       
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
      user_id: state.user_id,
      dataQuest1 : state.getQuestPID_StandAloneRed,
      result: state.submitPID_StandAloneRed,
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        getQuestPID_StandAlone: (data) =>{
        dispatch(getQuestPID_StandAlone(data))
      },
      submit1: (result) => {
        dispatch(submitPID_StandAlone(result));
      },
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(componentName);